<template>
  <DialogContainer
    :showDialog="showDialog"
    title="Edit Status"
    icon="edit"
    :toolbarActions="[
      {
        text: 'Save',
        icon: 'save',
        buttonColor: 'success',
        emitEvent: 'onSubmitClicked',
        showIsLoading: true,
        isDisabledFunc: () => !isFormValid,
      },
      {
        text: 'Cancel',
        depressed: true,
        emitEvent: 'onCancelClicked',
      },
    ]"
    @onCancelClicked="onCancelClicked"
    @onSubmitClicked="onSubmitClicked"
    :isLoading="isLoading"
  >
    <v-container pa-0 grid-list-lg>
      <v-form v-model="isFormValid" ref="form">
        <v-layout wrap>
          <v-flex xs12>
            <ControlTextField
              label="AssetStatus Name*"
              autofocus
              v-model="name"
              :disabled="isLoading"
              :rules="[(v) => !!v || 'Required']"
            />
          </v-flex>
          <v-flex xs12>
            <ControlAutoComplete
              :items="enabledActivityTypeList"
              autocomplete
              multiple
              item-text="name"
              item-value="id"
              v-model="activityTypeIds"
              clearable
              label="Activity types available when in this status"
              :disabled="isLoading"
            />
          </v-flex>
          <v-flex xs12>
            <ControlCheckbox
              v-model="inUse"
              label="Is equipment in use when in this status?"
              :disabled="isLoading"
            />
          </v-flex>
          <v-flex xs12>
            <ControlCheckbox
              v-model="isEnabled"
              label="Enabled?"
              :disabled="isLoading"
            />
          </v-flex>
        </v-layout>
        <small>*indicates required field</small>
      </v-form>
    </v-container>
  </DialogContainer>
</template>

<script>
import DialogContainer from '../../../common/components/layouts/DialogContainer'
import ControlTextField from '../../../common/components/controls/ControlTextField'
import ControlCheckbox from '../../../common/components/controls/ControlCheckbox'
import ControlAutoComplete from '../../../common/components/controls/ControlAutoComplete'

export default {
  components: {
    DialogContainer,
    ControlTextField,
    ControlCheckbox,
    ControlAutoComplete,
  },
  props: {
    showDialog: {
      type: Boolean,
      required: true,
    },
    assetStatusToEdit: {
      type: Object,
      required: true,
    },
    activityTypeList: {
      type: Array,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    isFormValid: false,
    id: null,
    name: null,
    activityTypeIds: null,
    inUse: null,
    isEnabled: null,
  }),
  computed: {
    enabledActivityTypeList() {
      return this.activityTypeList.filter(
        (activityType) => activityType.isEnabled
      )
    },
  },
  watch: {
    showDialog() {
      if (this.showDialog && this.assetStatusToEdit.id) {
        this.id = this.assetStatusToEdit.id
        this.activityTypeIds = this.assetStatusToEdit.activityTypeIds || []
        this.name = this.assetStatusToEdit.name
        this.inUse = !this.assetStatusToEdit.isIdle
        this.isEnabled = this.assetStatusToEdit.isEnabled
      }
      if (!this.showDialog) {
        this.clearDialog()
      }
    },
  },
  methods: {
    onSubmitClicked() {
      this.$emit('onSubmitClicked', {
        id: this.id,
        name: this.name,
        activityTypeIds: this.activityTypeIds || [],
        isIdle: !this.inUse,
        isEnabled: this.isEnabled,
      })
    },
    onCancelClicked() {
      this.$emit('onCancelClicked')
    },
    clearDialog() {
      this.$refs.form.reset()
      this.id = null
      this.activityTypeIds = null
      this.name = null
      this.inUse = null
      this.isEnabled = null
    },
  },
}
</script>